<script>
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  
  export default {
    components: { datepicker },
    props: {
      solicitacao: {
        type: Object,
        required: true
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");

        return this.$validator.validateAll();
      },
    },
    computed: {
      finalidadeViagemContador() {
        let quantidadeCaracteres = this.solicitacao.finalidadeViagem ?
          this.solicitacao.finalidadeViagem.length : 0;

        return 350 - quantidadeCaracteres;
      },
    },
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('localidade')}">
          <label class="control-label" for="localidade">Localidade</label>

          <input 
            type="text"
            class="form-control"
            id="localidade"
            v-model="solicitacao.localidade"
            data-vv-name="localidade"
            data-vv-as="localidade"
            v-validate="!!solicitacao.adiantamentoViagem ? 'required' : ''"
            maxlength="100">

          <p class="text-danger" v-show="errors.has('localidade')">{{ errors.first('localidade') }}</p>
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('dataPartida')}">
          <label class="control-label">Partida</label>

          <datepicker
            id="dataPartida"
            v-model="solicitacao.dataPartida"
            format="dd/MM/yyyy"
            placeholder="  /  /     "
            lang="pt-BR"
            data-vv-name="dataPartida"
            data-vv-as="partida"
            v-mascara="'data-mask'"
            v-validate="!!solicitacao.adiantamentoViagem ? 'required|date_format:DD/MM/YYYY' : ''">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataPartida')">{{ errors.first('dataPartida') }}</p>
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('dataRetorno')}">
          <label class="control-label">Retorno</label>

          <datepicker
            id="dataRetorno"
            v-model="solicitacao.dataRetorno"
            format="dd/MM/yyyy"
            placeholder="  /  /     "
            lang="pt-BR"
            data-vv-name="dataRetorno"
            data-vv-as="retorno"
            v-mascara="'data-mask'"
            v-validate="!!solicitacao.adiantamentoViagem ? 'required|date_format:DD/MM/YYYY' : ''">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataRetorno')">{{ errors.first('dataRetorno') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('finalidadeViagem')}">
          <label class="control-label" for="finalidade-viagem">Finalidade da viagem ({{ finalidadeViagemContador }})</label>

          <textarea
            class="form-control"
            id="finalidade-viagem"
            v-model="solicitacao.finalidadeViagem"
            data-vv-name="finalidadeViagem"
            data-vv-as="finalidade da viagem"
            v-validate="!!solicitacao.adiantamentoViagem ? 'required' : ''"
            maxlength="350">
          </textarea>

          <p class="text-danger" v-show="errors.has('finalidadeViagem')">{{ errors.first('finalidadeViagem') }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-adiantamento/componentes/compartilhado/FormDadosViagem.vue